import { KeKontroleEnum } from "../api";

export const keysOfKeKontrole = Object.keys(KeKontroleEnum);

export const getKeKontroleCaption = (typ: string | KeKontroleEnum): string => {
  switch (typ) {
    case "EXTERNI":
      return "Externí náklady";
    case "INTERNI":
      return "Vlastní náklady";
    case "RENTABILITA":
      return "Rentabilita";
  }
};

export const getKeKontroleItems = (): {
  id: KeKontroleEnum;
  name: string;
}[] => {
  return keysOfKeKontrole.map((t: KeKontroleEnum) => ({
    id: t,
    name: getKeKontroleCaption(t),
  }));
};
